module.exports = __webpack_public_path__ + "img/swiper-1.84b51b4.png";